import React from "react";
import { motion } from "framer-motion";
const LiveBadge = () => {
    return (
        <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="flex items-center space-x-2 px-3 py-1 rounded-full bg-danger-600 text-white shadow-hp-sm cursor-pointer max-w-fit"
        >
            {/* Lien cliquable vers Bloomberg */}
            <a
                href="https://www.bloomberg.com/live"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2"
            >
                {/* Point clignotant rouge */}
                <div className="w-2 h-2 rounded-full bg-white animate-pulse"></div>

                {/* Logo responsive */}
                <img
                    src={'/assets/bloomberg-logo.jpg'}
                    alt="Bloomberg"
                    className="h-5 w-auto rounded-sm hover:opacity-80 transition duration-200 bg-white p-0"
                />
            </a>

            {/* Texte Live Streaming responsive */}
            <p className="text-[0.7rem] sm:text-sm leading-tight font-bold m-0">
                Live Streaming
            </p>
        </motion.div>
    );
};

export default LiveBadge;
